import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const socialContent = [
  {
    icon: "fa-facebook",
    link: "https://www.facebook.com/UseKushStack",
  },
  {
    icon: "fa-instagram",
    link: "https://www.instagram.com/UseKushStack",
  },
  {
    icon: "fa-twitter",
    link: "https://www.twitter.com/UseKushStack",
  },

  {
    icon: "fa-linkedin",
    link: "https://www.linkedin.com/company/kushstack",
  },
];

const ComingSoon = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  return (
    <>
      <Helmet>
        <title>
          KushStack | Modernized Cannabis Technology
        </title>
      </Helmet>
      {/* End Page SEO Content */}
      <div className="full-height-layout d-flex align-items-center">
        <div className="coming-soon-content font-gordita">
          <div className="logo coming-soon-brand">
            <Link to="/">
              <img src="images/logo/logo_horizontal.svg" alt="kushstack logo" />
            </Link>
          </div>
          <h6>COMING SOON</h6>
          <h1 data-aos="fade-up">We're modernizing cannabis software.</h1>
          <div className="row">
            <div className="col-lg-9 m-auto">
              <p>
                Join us on our journey, more info coming soon!
              </p>
            </div>
          </div>
          {/* <form onClick={handleSubmit}>
            <input type="email" placeholder="john@smith.net" />
            <button>Notify Me</button>
          </form> */}

          <ul className="social-icon d-flex justify-content-center">
            {socialContent.map((val, i) => (
              <li key={i}>
                <a href={val.link} target="_blank" rel="noreferrer">
                  <i className={`fa ${val.icon}`}></i>
                </a>
              </li>
            ))}
          </ul>

          <img
            src="images/shape/179.svg"
            alt="shape"
            className="shapes shape-one"
          />
          <img
            src="images/shape/180.svg"
            alt="shape"
            className="shapes shape-two"
          />
          <img
            src="images/shape/181.svg"
            alt="shape"
            className="shapes shape-three"
          />
          <img
            src="images/shape/182.svg"
            alt="shape"
            className="shapes shape-four"
          />
          <img
            src="images/shape/183.svg"
            alt="shape"
            className="shapes shape-five"
          />
          <img
            src="images/shape/184.svg"
            alt="shape"
            className="shapes shape-six"
          />
          <img
            src="images/shape/185.svg"
            alt="shape"
            className="shapes shape-seven"
          />
          <img
            src="images/shape/186.svg"
            alt="shape"
            className="shapes shape-eight"
          />
          <img
            src="images/shape/187.svg"
            alt="shape"
            className="shapes shape-nine"
          />
          <img
            src="images/shape/188.svg"
            alt="shape"
            className="shapes shape-ten"
          />
        </div>
        {/* /.coming-soon-content */}
      </div>
    </>
  );
};

export default ComingSoon;
